import { html, nothing, unsafeCSS, type CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';
import itemCss from './lib-breadcrumb-item.css';

@customElement('lib-breadcrumb-item')
export class LibBreadcrumbItem extends LibElement {
  protected override get hostFocusSelector(): string { return 'a[href], button'; }
  static override readonly styles: CSSResultGroup = [LibElement.hostStyles, unsafeCSS(itemCss)];
  @property() href = '';
  @property({ type: Boolean, reflect: true }) active = false;
  @property({ type: Boolean }) separator = false;

  override render() {
    const content = html`<slot name="icon"></slot><span class="lib-breadcrumb-text"><slot></slot></span>`;
    let link;
    if (this.active) link = html`<span class="lib-breadcrumb-link lib-breadcrumb-link-active" aria-current="page">${content}</span>`;
    else if (this.href) link = html`<a class="lib-breadcrumb-link" href=${this.href}>${content}</a>`;
    else link = html`<button type="button" class="lib-breadcrumb-link">${content}</button>`;
    const separator = this.separator ? html`<lib-icon class="separator" icon-url="./_content/WAGO.SolutionsPlatform.UILibrary.Core/wago-icons-svg/chevron-right.svg" aria-hidden="true"></lib-icon>` : nothing;
    return html`${separator}
      ${link}`;
  }
}

declare global {
  interface HTMLElementTagNameMap { 'lib-breadcrumb-item': LibBreadcrumbItem; }
}
